/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './app/routing/__root'
import { Route as ConsoleRouteImport } from './app/routing/_console'
import { Route as BillingRouteImport } from './app/routing/billing'
import { Route as DashboardRouteImport } from './app/routing/dashboard'
import { Route as ProductsRouteImport } from './app/routing/products'
import { Route as ReportsRouteImport } from './app/routing/reports'
import { Route as StrategyRouteImport } from './app/routing/strategy'
import { Route as ConsoleIndexRouteImport } from './app/routing/_console.index'
import { Route as ConsoleInboxRouteImport } from './app/routing/_console.inbox'
import { Route as ConsoleKnowledgeRouteImport } from './app/routing/_console.knowledge'
import { Route as ConsolePlaygroundRouteImport } from './app/routing/_console.playground'
import { Route as ConsoleSettingsRouteImport } from './app/routing/_console.settings'

const ConsoleRoute = ConsoleRouteImport.update({
  id: '/_console',
  getParentRoute: () => rootRouteImport,
} as any)
const BillingRoute = BillingRouteImport.update({
  id: '/billing',
  path: '/billing',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardRoute = DashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => rootRouteImport,
} as any)
const ProductsRoute = ProductsRouteImport.update({
  id: '/products',
  path: '/products',
  getParentRoute: () => rootRouteImport,
} as any)
const ReportsRoute = ReportsRouteImport.update({
  id: '/reports',
  path: '/reports',
  getParentRoute: () => rootRouteImport,
} as any)
const StrategyRoute = StrategyRouteImport.update({
  id: '/strategy',
  path: '/strategy',
  getParentRoute: () => rootRouteImport,
} as any)
const ConsoleIndexRoute = ConsoleIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ConsoleRoute,
} as any)
const ConsoleInboxRoute = ConsoleInboxRouteImport.update({
  id: '/inbox',
  path: '/inbox',
  getParentRoute: () => ConsoleRoute,
} as any)
const ConsoleKnowledgeRoute = ConsoleKnowledgeRouteImport.update({
  id: '/knowledge',
  path: '/knowledge',
  getParentRoute: () => ConsoleRoute,
} as any)
const ConsolePlaygroundRoute = ConsolePlaygroundRouteImport.update({
  id: '/playground',
  path: '/playground',
  getParentRoute: () => ConsoleRoute,
} as any)
const ConsoleSettingsRoute = ConsoleSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => ConsoleRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof ConsoleIndexRoute
  '/billing': typeof BillingRoute
  '/dashboard': typeof DashboardRoute
  '/products': typeof ProductsRoute
  '/reports': typeof ReportsRoute
  '/strategy': typeof StrategyRoute
  '/inbox': typeof ConsoleInboxRoute
  '/knowledge': typeof ConsoleKnowledgeRoute
  '/playground': typeof ConsolePlaygroundRoute
  '/settings': typeof ConsoleSettingsRoute
}
export interface FileRoutesByTo {
  '/billing': typeof BillingRoute
  '/dashboard': typeof DashboardRoute
  '/products': typeof ProductsRoute
  '/reports': typeof ReportsRoute
  '/strategy': typeof StrategyRoute
  '/inbox': typeof ConsoleInboxRoute
  '/knowledge': typeof ConsoleKnowledgeRoute
  '/playground': typeof ConsolePlaygroundRoute
  '/settings': typeof ConsoleSettingsRoute
  '/': typeof ConsoleIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_console': typeof ConsoleRouteWithChildren
  '/billing': typeof BillingRoute
  '/dashboard': typeof DashboardRoute
  '/products': typeof ProductsRoute
  '/reports': typeof ReportsRoute
  '/strategy': typeof StrategyRoute
  '/_console/inbox': typeof ConsoleInboxRoute
  '/_console/knowledge': typeof ConsoleKnowledgeRoute
  '/_console/playground': typeof ConsolePlaygroundRoute
  '/_console/settings': typeof ConsoleSettingsRoute
  '/_console/': typeof ConsoleIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/billing'
    | '/dashboard'
    | '/products'
    | '/reports'
    | '/strategy'
    | '/inbox'
    | '/knowledge'
    | '/playground'
    | '/settings'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/billing'
    | '/dashboard'
    | '/products'
    | '/reports'
    | '/strategy'
    | '/inbox'
    | '/knowledge'
    | '/playground'
    | '/settings'
    | '/'
  id:
    | '__root__'
    | '/_console'
    | '/billing'
    | '/dashboard'
    | '/products'
    | '/reports'
    | '/strategy'
    | '/_console/inbox'
    | '/_console/knowledge'
    | '/_console/playground'
    | '/_console/settings'
    | '/_console/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  ConsoleRoute: typeof ConsoleRouteWithChildren
  BillingRoute: typeof BillingRoute
  DashboardRoute: typeof DashboardRoute
  ProductsRoute: typeof ProductsRoute
  ReportsRoute: typeof ReportsRoute
  StrategyRoute: typeof StrategyRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_console': {
      id: '/_console'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof ConsoleRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/billing': {
      id: '/billing'
      path: '/billing'
      fullPath: '/billing'
      preLoaderRoute: typeof BillingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard': {
      id: '/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof DashboardRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/products': {
      id: '/products'
      path: '/products'
      fullPath: '/products'
      preLoaderRoute: typeof ProductsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reports': {
      id: '/reports'
      path: '/reports'
      fullPath: '/reports'
      preLoaderRoute: typeof ReportsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/strategy': {
      id: '/strategy'
      path: '/strategy'
      fullPath: '/strategy'
      preLoaderRoute: typeof StrategyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_console/': {
      id: '/_console/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof ConsoleIndexRouteImport
      parentRoute: typeof ConsoleRoute
    }
    '/_console/inbox': {
      id: '/_console/inbox'
      path: '/inbox'
      fullPath: '/inbox'
      preLoaderRoute: typeof ConsoleInboxRouteImport
      parentRoute: typeof ConsoleRoute
    }
    '/_console/knowledge': {
      id: '/_console/knowledge'
      path: '/knowledge'
      fullPath: '/knowledge'
      preLoaderRoute: typeof ConsoleKnowledgeRouteImport
      parentRoute: typeof ConsoleRoute
    }
    '/_console/playground': {
      id: '/_console/playground'
      path: '/playground'
      fullPath: '/playground'
      preLoaderRoute: typeof ConsolePlaygroundRouteImport
      parentRoute: typeof ConsoleRoute
    }
    '/_console/settings': {
      id: '/_console/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof ConsoleSettingsRouteImport
      parentRoute: typeof ConsoleRoute
    }
  }
}

interface ConsoleRouteChildren {
  ConsoleInboxRoute: typeof ConsoleInboxRoute
  ConsoleKnowledgeRoute: typeof ConsoleKnowledgeRoute
  ConsolePlaygroundRoute: typeof ConsolePlaygroundRoute
  ConsoleSettingsRoute: typeof ConsoleSettingsRoute
  ConsoleIndexRoute: typeof ConsoleIndexRoute
}

const ConsoleRouteChildren: ConsoleRouteChildren = {
  ConsoleInboxRoute: ConsoleInboxRoute,
  ConsoleKnowledgeRoute: ConsoleKnowledgeRoute,
  ConsolePlaygroundRoute: ConsolePlaygroundRoute,
  ConsoleSettingsRoute: ConsoleSettingsRoute,
  ConsoleIndexRoute: ConsoleIndexRoute,
}

const ConsoleRouteWithChildren =
  ConsoleRoute._addFileChildren(ConsoleRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  ConsoleRoute: ConsoleRouteWithChildren,
  BillingRoute: BillingRoute,
  DashboardRoute: DashboardRoute,
  ProductsRoute: ProductsRoute,
  ReportsRoute: ReportsRoute,
  StrategyRoute: StrategyRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
